<template>
  <v-dialog
    v-model="modalDeleterealisation"
    persistent
    max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Supprimer une réalisation</span>
      </v-card-title>
      <v-card-text v-if="modalDeleterealisation">
        <v-container>
          Êtes-vous sûr de vouloir supprimer {{ editrealisation.titre }}?
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="warning darken-1"
          text
          @click="closeModal('Deleterealisation')">Annuler</v-btn>
        <v-btn
          color="primary darken-1"
          text
          @click="deleteRealisation()">Valider la suppression</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'
import { db, storage } from '@/plugins/firebase'

export default {
  data: () => ({
    show: false,
    invalidlog: false,
    rules: {
      required: value => !!value || 'Champs requis.',
      min: v => v.length >= 8 || 'Min 8 caractères',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Courriel invalide.'
      }
    }
  }),
  computed: {
    ...mapGetters([
      'modalDeleterealisation',
      'editrealisation'
    ])
  },
  methods: {
    ...mapActions(['closeModal']),
    deleteRealisation () {
      const $this = this
      let stepimgs = 0
      if (this.editrealisation.couverturename) {
        this.editrealisation.couverturename.forEach(image => {
          const oldimg = storage.ref().child('images/' + image)

          oldimg.delete().then(function () { stepimgs++ })

          if (this.editrealisation.couverturename === stepimgs) {
            db.collection('realisations').doc($this.editrealisation.id).delete()
              .then(function () {
                console.log('Document supprimé!')
              }).catch(function (error) {
                console.error('Erreur de suppression du document: ', error)
              })
            $this.closeModal('Deleterealisation')
          }
        })
      } else {
        db.collection('realisations').doc(this.editrealisation.id).delete()
          .then(function () {
            console.log('Document supprimé!')
          }).catch(function (error) {
            console.error('Erreur de suppression du document: ', error)
          })
        this.closeModal('Deleterealisation')
      }
    }
  }
}
</script>
